import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-call-details-eval-card-row',
  templateUrl: './call-details-eval-card-row.component.html',
  styleUrls: ['./call-details-eval-card-row.component.scss'],
  providers: [],
})
export class CallDetailsEvalCardRowComponent {
  @Input() evalPoint: any;
  @Input() header: boolean = false;
  @Input() print: boolean = false;
}
